import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  HostListener,
} from "@angular/core";
import { NgbDropdownConfig } from "@ng-bootstrap/ng-bootstrap";
import { AnimationBuilder, AnimationService } from "css-animator";
import {
  animate,
  AUTO_STYLE,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";

import {
  ConnectedPositioningStrategy,
  HorizontalAlignment,
  IgxDropDownComponent,
  ISelectionEventArgs,
  NoOpScrollStrategy,
  VerticalAlignment,
} from "igniteui-angular";
import { Router } from "@angular/router";
import { DetectDeviceService } from "src/app/services/core/detect-device.service";
import { SwiperFixService } from "src/app/services/admin/swiper-fix.service";
import { FullScreenToggleService } from "src/app/services/core/full-screen-toggle.service";



@Component({
  selector: "app-card",
  templateUrl: "./card.component.html",
  styleUrls: ["./card.component.scss"],
  providers: [NgbDropdownConfig],
  animations: [
    trigger("collapsedCard", [
      state(
        "collapsed, void",
        style({
          overflow: "hidden",
          height: "0px",
        })
      ),
      state(
        "expanded",
        style({
          overflow: "hidden",
          height: AUTO_STYLE,
        })
      ),
      transition("collapsed <=> expanded", [animate("400ms ease-in-out")]),
    ]),
    trigger("cardRemove", [
      state(
        "open",
        style({
          opacity: 1,
        })
      ),
      state(
        "closed",
        style({
          opacity: 0,
          display: "none",
        })
      ),
      transition("open <=> closed", animate("400ms")),
    ]),
  ],
})
export class CardComponent implements OnInit {
  @Input() cardTitle: string;
  @Input() cardClass: string = "";
  cardClassHolder = "";
  @Input() blockClass: string;
  @Input() headerClass: string;
  @Input() Badge?: string;
  @Input() options: boolean;
  @Input() hidHeader: boolean;

  /**************************************************TODO **********************************/
  @Input() addButtonOne: boolean;
  @Input() addButtonOneTitle: string;
  @Input() ButtonOneIcon: string;
  @Input() addButtonTwo: boolean;
  @Input() addButtonTwoTitle: string;
  @Input() ButtonTwoIcon: string;
  @Input() addButtonThree: boolean;
  @Input() addButtonThreeTitle: string;
  @Input() ButtonThreeIcon: string;
  @Input() addButtonFour: boolean;
  @Input() addButtonFourTitle: string;
  @Input() ButtonFourIcon: string;
  @Input() addButtonFive: boolean;
  @Input() addButtonFiveTitle: string;
  @Input() ButtonFiveIcon: string;
  /**************************************************END TODO **********************************/

  @Input() customHeader: boolean;
  @Output() buttonOneClicked = new EventEmitter();
  @Output() buttonTwoClicked = new EventEmitter();
  @Output() buttonThreeClicked = new EventEmitter();
  @Output() buttonFourClicked = new EventEmitter();
  @Output() buttonFiveClicked = new EventEmitter();

  @Input() buttonOneDisabled = false;
  @Input() buttonTwoDisabled = false;
  @Input() buttonThreeDisabled = false;
  @Input() buttonFourDisabled = false;
  @Input() buttonFiveDisabled = false;

  @Input() dropdownTitle: string = "Action";
  @Input() dropdownEnabled: boolean = false;
  @Input() dropdownItemsTitle: string[] = [];
  @Input() dropdownItemsIcon: string[] = [];
  @Output() onDropdownItemClicked = new EventEmitter();

  @Input() checkboxEnabled: boolean = false;
  @Input() checkboxState: boolean = false;
  @Output() checkboxStateChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @Input() useIcon: boolean = true;

  @Input() ignoreTitleCase: boolean = true;

  @Input() fillScreen: boolean = false;
  
  @Input() buttonOneLoading: boolean = false;
  @Input() buttonTwoLoading: boolean = false;
  @Input() buttonThreeLoading: boolean = false;
  @Input() buttonFourLoading: boolean = false;
  @Input() buttonFiveLoading: boolean = false;

  public animation: string;
  public fullIcon: string;
  public isAnimating: boolean;
  public animator: AnimationBuilder;
  public animators: AnimationBuilder;

  public collapsedCard: string;
  public collapsedIcon: string;

  public loadCard: boolean;

  public cardRemove: string;

  overlaySettings = {
    positionStrategy: new ConnectedPositioningStrategy({
      horizontalDirection: HorizontalAlignment.Left,
      horizontalStartPoint: HorizontalAlignment.Right,
      verticalStartPoint: VerticalAlignment.Bottom,
    }),
    scrollStrategy: new NoOpScrollStrategy(),
  };

  @ViewChild("toAnimate", { static: false }) toAnimateRef;

  @ViewChild("menu", { static: false, read: IgxDropDownComponent })
  menu: IgxDropDownComponent;

  @Input() fullScreenQuery: string;

  isMobile = false;

  dataPack: {
    titles,
    icons,
    actions
  }

  constructor(
    private swiperFixService: SwiperFixService,
    animationService: AnimationService,
    config: NgbDropdownConfig,
    private fullscreenToggleService: FullScreenToggleService,
    private detectDeviceService: DetectDeviceService,
    private router: Router
  ) {
    config.placement = "bottom-right";
    this.customHeader = false;
    this.options = true;
    this.hidHeader = false;

    /**************************************************TODO **********************************/
    this.addButtonOne = false;
    this.addButtonOneTitle = "Default";
    this.addButtonTwo = false;
    this.addButtonThree = false;
    this.addButtonFour = false;
    this.cardTitle = "Card Title";
    this.Badge = null;
    /**************************************************END TODO******************************/

    this.animator = animationService.builder();
    this.animators = animationService.builder();
    this.animator.useVisibility = true;
    this.fullIcon = "icon-maximize";
    this.isAnimating = false;

    this.collapsedCard = "expanded";
    this.collapsedIcon = "icon-minus";

    this.loadCard = false;

    this.cardRemove = "open";
  }

  ngOnInit() {
    this.cardClassHolder = this.cardClass;

    if (!this.options || this.hidHeader || this.customHeader) {
      this.collapsedCard = "false";
    }

    if (this.dropdownEnabled)
      this.dropdownItemsIcon = [
        ...this.dropdownItemsIcon,
        ...["feather icon-maximize", "feather icon-refresh-cw"],
      ];

    this.onWindowResize();
  }

  @HostListener("window:resize", ["$event"])
  onWindowResize(){
    this.handleMobileView();
    this.isMobile = this.isOnMobile();
  }

  reloadCurrentPage(){
    const currentUrl = this.router.routerState.snapshot.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
    this.router.navigate([currentUrl]));
   }

  handleMobileView(){
    const buttonTitles = [];
    const buttonIcons = [];
    const buttonActions = [];
    const tempTitles = ['addButtonOneTitle', 'addButtonTwoTitle', 'addButtonThreeTitle', 'addButtonFourTitle', 'addButtonFiveTitle'];
    const tempIcons = [this.ButtonOneIcon, this.ButtonTwoIcon, this.ButtonThreeIcon, this.ButtonFourIcon, this.ButtonFiveIcon];
    const tempActions = [this.buttonOneClicked, this.buttonTwoClicked, this.buttonThreeClicked, this.buttonFourClicked, this.buttonFiveClicked];
    const tempDisabled = [this.buttonOneDisabled, this.buttonTwoDisabled, this.buttonThreeDisabled, this.buttonFourDisabled, this.buttonFiveDisabled];

    [this.addButtonOne, this.addButtonTwo, this.addButtonThree, this.addButtonFour, this.addButtonFive].forEach(
      (enabled, index) => {
        if(enabled && !tempDisabled[index]){
          buttonTitles.push(this[tempTitles[index]].toUpperCase());
          buttonIcons.push(tempIcons[index]);
          buttonActions.push(() => {
            tempActions[index].emit();
          });
        }
      }
    );
    if(this.dropdownEnabled){
      this.dropdownItemsTitle.forEach((item, index) => {
        buttonTitles.push(item.toUpperCase());
        buttonIcons.push(this.dropdownItemsIcon[index]);
        buttonActions.push(() => {
          this.onDropdownItemClicked.emit(index);
        });
      });
    }
    // ("mobile-view");
    const dataPack = {
      titles: buttonTitles,
      icons: buttonIcons,
      actions: buttonActions
    }

    this.dataPack = dataPack;
    return this.dataPack;
  }

  isOnMobile(){
    return this.detectDeviceService.isMobileDevice();
  }

  handleButtonOneClick() {
    this.buttonOneClicked.emit();
  }

  handleButtonTwoClick() {
    this.buttonTwoClicked.emit();
  }

  handleButtonThreeClick() {
    this.buttonThreeClicked.emit();
  }

  handleButtonFourClick() {
    this.buttonFourClicked.emit();
  }

  handleButtonFiveClick() {
    this.buttonFiveClicked.emit();
  }

  public onDDSelection(eventArgs: ISelectionEventArgs) {
    (eventArgs);
    if (eventArgs.newSelection == undefined) return;
    this.onDropdownListItemClicked(eventArgs.newSelection.itemIndex);
    setTimeout(() => {
      eventArgs.newSelection.selected = false;
    }, 100);
    // // const text = eventArgs.newSelection.value;
    // // setTimeout(() => {
    //   eventArgs.cancel = true;
    //   this.menu.close();
    // }, 200);
  }

  getDropdownList() {
    if (this.dropdownEnabled) {
      if (this.fullScreenQuery) {
        return [
          ...this.dropdownItemsTitle,
          document
            .querySelector(this.fullScreenQuery)
            .classList.contains("fullscreen-card-bg")
            ? "Restore"
            : "Maximize",
          "Reload",
        ];
      } else {
        return [
          ...this.dropdownItemsTitle,
          this.fullIcon !== "icon-maximize" ? "Restore" : "Maximize",
          "Reload",
        ];
      }
    } else {
      if (this.fullScreenQuery) {
        return [
          document
            .querySelector(this.fullScreenQuery)
            .classList.contains("fullscreen-card-bg")
            ? "Restore"
            : "Maximize",
          "Reload",
        ];
      } else {
        return [
          this.fullIcon !== "icon-maximize" ? "Restore" : "Maximize",
          "Reload",
        ];
      }
    }
  }

  onDropdownListItemClicked(eventIndex) {
    (eventIndex);
    this.menu.clearSelection();
    const arrayTemp = this.dropdownEnabled
      ? [...this.dropdownItemsTitle, ...["Maximize", "Reload"]]
      : ["Maximize", "Reload"];
    const defaultOptionsHandler = [
      () => {
        ("test");
        this.fullCardToggle(this.toAnimateRef.nativeElement, "", true);
      },
      this.reloadCurrentPage,
      // this.cardRefresh,
    ];
    if (eventIndex < arrayTemp.length - 2)
      this.onDropdownItemClicked.emit(eventIndex);
    else {
      const index = arrayTemp.length - eventIndex;
      if (index === 1) defaultOptionsHandler[1]();
      else defaultOptionsHandler[0]();
    }
  }

  toFullScreen() {
    const isMaximize = this.fullIcon === "icon-maximize";
    if (isMaximize) {
      const element = document.querySelector(this.fullScreenQuery);
      element.requestFullscreen();
      element.classList.add("fullscreen-card-bg");
    } else {
      document.exitFullscreen();
      const element = document.querySelector(this.fullScreenQuery);
      element.classList.remove("fullscreen-card-bg");
    }
    this.fullIcon = !document
      .querySelector(this.fullScreenQuery)
      .classList.contains("fullscreen-card-bg")
      ? "icon-maximize"
      : "icon-minimize";
    this.dropdownItemsIcon[this.dropdownItemsIcon.length - 2] =
      "feather " + this.fullIcon;
  }

  public fullCardToggle(
    element: HTMLElement,
    animation: string,
    status: boolean
  ) {
    if (this.fullScreenQuery) {
      this.toFullScreen();
      return;
    }
    animation = this.cardClass === "full-card" ? "zoomOut" : "zoomIn";
    this.fullIcon =
      this.cardClass === "full-card" ? "icon-maximize" : "icon-minimize";
    this.dropdownItemsIcon[this.dropdownItemsIcon.length - 2] =
      "feather " + this.fullIcon;
    // const duration = this.cardClass === 'full-card' ? 300 : 600;

    this.swiperFixService.fullscreenFix(
      this.cardClass === "full-card" ? false : true
    );

    this.cardClass =
      this.cardClass === "full-card" ? this.cardClass : "full-card";

    if (status) {
      this.animation = animation;
    }
    this.isAnimating = true;

    this.animators
      .setType(this.animation)
      .setDuration(500)
      .setDirection("alternate")
      .setTimingFunction("cubic-bezier(0.1, -0.6, 0.2, 0)")
      .animate(element)
      .then(() => {
        this.isAnimating = false;
      })
      .catch((e) => {
        this.isAnimating = false;
      });
    setTimeout(() => {
      this.cardClass =
        animation === "zoomOut" ? this.cardClassHolder : this.cardClass;
      if (this.cardClass === "full-card") {
        document.querySelector("body").style.overflow = "hidden";
      } else {
        document.querySelector("body").removeAttribute("style");
      }
      this.fullscreenToggleService.fullScreenEmitter.emit(true);
    }, 500);
  }

  collapsedCardToggle(event) {
    this.collapsedCard =
      this.collapsedCard === "collapsed" ? "expanded" : "collapsed";
    this.collapsedIcon =
      this.collapsedCard === "collapsed" ? "icon-plus" : "icon-minus";
  }

  cardRefresh() {
    this.loadCard = true;
    this.cardClass = "card-load";
    setTimeout(() => {
      this.loadCard = false;
      this.cardClass = "expanded";
    }, 3000);
  }

  public startLoadCard(state = true){
    if(state){
      this.loadCard = true;
      this.cardClass += " card-load";
    } else{
      this.loadCard = false;
      this.cardClass.replace(" card-load", "");
    }
  }

  cardRemoveAction(event) {
    this.cardRemove = this.cardRemove === "closed" ? "open" : "closed";
  }
}
